// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"hs-z","imageAndVideoCount":"is-z","imageAndVideoContainer":"js-z","viewAllReviews":"ks-z"};